import { OptionHelpers } from '../../helpers/option-helpers';
import { IChartContainer } from '../../models/base/chart-container.interface';
import { TimeframeOptionModel } from '../../models/drop-down-list/timeframe-option.model';
import { Timeframe } from '../../models/enum/timeframe.enum';
import { TiChartMenuContainer } from "../../ti-chart-menu.container";
import { IComponent } from "../component.interface";
import { DrawTradePriceAnnotationComponent } from '../draw-trade-price-annotation.model';
import { PnlComponent } from '../pnl.component';

export class TimeframeIconComponent implements IComponent {
    public id = '';

    private timeframeOptions = OptionHelpers.getTimeframeOptions();
    private currentTimeframe: TimeframeOptionModel = this.timeframeOptions[0];
    private tiChartMenuContainer: TiChartMenuContainer;
    private base: IChartContainer;
    private element: HTMLElement;

    constructor(el: HTMLElement, tiChartMenuContainer: TiChartMenuContainer, base: IChartContainer) {
        this.element = el;
        this.tiChartMenuContainer = tiChartMenuContainer;
        this.base = base;
        this.onClick();
        this.onOptionsClick();
        this.onResize();
    }

    public setCurrentTimeframe(timeframe: Timeframe) {
        const op = this.element.findFirst('.tf[data-value="' + timeframe + '"]');
        if (!op) { return; }
        this.setElementActive(op);
        const option = this.timeframeOptions.find((x: TimeframeOptionModel) => x.value == parseInt(op.dataset.value, 10));
        if (option) {
            this.currentTimeframe = option;
        }
    }
    
    private onClick() {
        this.element.addEventListener('click', (event: any) => {
            event.stopPropagation();
            this.toggleTimeframe(!this.tiChartMenuContainer.displayTimeframe);
        });
    }

    private onOptionsClick() {
        const allOptions = this.element.querySelectorAll<HTMLElement>('.tf');
        allOptions.forEach((op: HTMLElement) => {
            op.addEventListener('click', (ev: any) => {
                ev.stopPropagation();
                this.selectTimeframeOption(op);
            });
        });
    }

    private toggleTimeframe(show: boolean) {
        this.tiChartMenuContainer.displayTimeframe = show;
        this.tiChartMenuContainer.displayTools = false;
        this.tiChartMenuContainer.displayIndicator = false;
        this.tiChartMenuContainer.displayChartType = false;
        this.base.hideTooltip();
        this.tiChartMenuContainer.toggleControls();
    }

    private selectTimeframeOption(op: HTMLElement | null) {
        if (!op) { return; }
        this.setElementActive(op);
        const option = this.timeframeOptions.find((x: TimeframeOptionModel) => x.value == parseInt(op.dataset.value, 10));
        if (this.currentTimeframe && option && this.currentTimeframe.value != option.value) {
            this.changeTimeframe(option);
        }
        this.tiChartMenuContainer.closeAllMenuControls();
    }
    
    private setElementActive(op: HTMLElement) {
        this.removeActiveElements();
        op.classList.add('active');
    }

    private changeTimeframe(timeframe: TimeframeOptionModel) {
        if (!this.base.tiChartSeries || this.currentTimeframe.value === timeframe.value) {
            return;
        }

        this.base.tiChartSeries.ready = false;
        this.currentTimeframe = timeframe;
        
        const pnlComponent = this.base.getComponentsByType(PnlComponent)[0] as PnlComponent;
        pnlComponent?.hideElements();

        const drawTradePriceAnnotationComponent = this.base.getComponentsByType(DrawTradePriceAnnotationComponent)[0] as DrawTradePriceAnnotationComponent;
        drawTradePriceAnnotationComponent?.remove();
        
        this.base.tiChartSeries.highChartComparisonBuilder?.removeComparisonsComponents(true);
        
        if (this.base.marketingWebChartMode && this.base.pnpMode) {
            const marketingContainer = this.base as any;
            const pnpChartService = marketingContainer.pnpContainer?.chartService;
            
            if (pnpChartService && marketingContainer.pnpSwitchComponent && marketingContainer.pnpSwitchComponent.switched) {
                marketingContainer.pnpSwitchComponent.togglePnPMode();
                pnpChartService.requestNewTimeframe(Timeframe.Day);
            }
        } else if (!this.base.marketingWebChartMode) {
            const container = this.base as any;
            const pnpChartService = container.pnpContainer?.chartService;

            if (pnpChartService && container.pnpSwitchComponent && container.pnpSwitchComponent.switched) {
                container.pnpSwitchComponent.togglePnPMode();
                pnpChartService.requestNewTimeframe(Timeframe.Day);
            } else {
                this.base.setComponentStateWhenRequestingNewSymbol(this.base.tiChartSeries.symbol, this.currentTimeframe.value);
            }
        }

        if (this.base.pnpMode) {
            this.base.tiChartSeries.currentTimeframe = timeframe.value;
            this.base.tiChartSeries.setPanel();
        }

        this.base.chartService.requestNewTimeframe(timeframe.value);
    }

    private removeActiveElements() {        
        this.element.querySelectorAll<HTMLElement>('.tf').forEach((op: HTMLElement) => {
            op.classList.remove('active');
        });
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.base.domEvents.onResize(() => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.toggleTimeframe(false);
            }, 150);
        });
    }
}
